export default "__VITE_ASSET__B2xsGWj5__"